<template>
  <div>
    <div class="sticky-search p-4">
      <search
        v-model.trim="typingTerm"
        v-dynamic-placeholder="{
          prefix: $t('icons.search-icon') || 'Search for',
          terms: termProposals
        }"
        @search="handleSearch"
      />
    </div>

    <div class="design-collection p-4">
      <div v-if="!term">
        <base-row
          v-for="searchKey in 11"
          :key="searchKey"
          class="pt-2 pb-2 no-underline justify-center text-2xl text-sh-secondary-darken-75 cursor-pointer"
          @click.native="
            () =>
              handleSelectPreselectionSearch($t(`design.search${searchKey}`))
          "
          >{{ $t(`design.search${searchKey}`) }}
        </base-row>
      </div>

      <div v-else>
        <collection :designs="designs" @item-clicked="designClicked" />
        <infinite-loading
          :identifier="term"
          class="pt-5"
          @infinite="fetchDesigns"
        >
          <div slot="spinner">
            <base-icon name="loading" alt="Loading..." />
          </div>
          <div slot="no-more"></div>
        </infinite-loading>

        <div
          v-if="designs.length > 24"
          class="flex flex-col items-center py-1 text-black group hover:cursor-pointer mt-10"
          @click="$root.$emit('scrollModalToTop')"
        >
          <base-icon
            name="arrow-up-icon"
            size="xs"
            class="group-hover:text-sh-primary"
          />
          <span class="group-hover:text-sh-primary text-xs">
            {{ $t('customization.top') }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CollectionGrid from '../../components/CollectionGrid.vue';
import {
  MUTATION_CLEAR_SEARCH,
  MUTATION_SEARCH_DESIGNS
} from '../../store/mutation-types';
import { ACTION_SEARCH_DESIGNS } from '../../store/action-types';
import Search from '../../components/input/Search.vue';
import { TrackingMixin } from '../../mixins/gtm-tracking';

export default {
  name: 'DesignList',
  components: {
    collection: CollectionGrid,
    Search
  },
  mixins: [TrackingMixin],
  data: () => ({
    isLoadingDesigns: false,
    isSearching: false,
    currentStart: 0,
    fetchLimit: 20,
    typingTerm: ''
  }),
  computed: {
    designs() {
      return this.$store.state.designs;
    },
    term: {
      get: function () {
        return this.$store.state.searchTerm;
      },
      set(value) {
        this.$store.commit(MUTATION_SEARCH_DESIGNS, value);
      }
    },
    termProposals() {
      return [...Array(11).keys()].flatMap(searchKey =>
        this.$t(`design.search${searchKey + 1}`)
      );
    }
  },
  mounted() {
    this.typingTerm = this.term;
    this.trackPath({
      contentGroup2: 'Creator_Motif',
      contentGroup3: 'Creator_Motif'
    });
  },
  methods: {
    handleSelectPreselectionSearch(preselectionTerm) {
      this.trackEvent({
        action: 'Motif_Search_Preselect',
        label: preselectionTerm.trim().toLowerCase()
      });
      this.handleSearch(preselectionTerm);
      this.typingTerm = preselectionTerm;
    },
    designClicked(design) {
      this.trackEvent({
        action: this.term ? 'Motif_Add_Search' : 'Motif_Add_Top',
        label: design.id
      });
      this.$emit('selectDesign', design);
    },
    handleSearch(term) {
      this.trackEvent({
        action: 'Motif_Search',
        label: term.trim().toLowerCase()
      });
      this.$store.commit(MUTATION_CLEAR_SEARCH);
      this.currentStart = 0;
      this.term = term;
    },
    async fetchDesigns(loadingState) {
      const loadedDesigns = this.designs.length;
      await this.$store.dispatch(ACTION_SEARCH_DESIGNS, [
        this.currentStart,
        this.fetchLimit,
        this.term.trim().toLowerCase(),
        this.$store.state.locale.replace('-', '_')
      ]);
      loadingState.loaded();
      this.isLoadingDesigns = false;
      this.currentStart += this.fetchLimit;
      if (this.designs.length === loadedDesigns) {
        loadingState.complete();
      }
    }
  }
};
</script>
<style>
.sticky-search {
  @apply pin-t bg-sh-pale-grey sticky z-10;
}
</style>
